import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { Injectable } from '@angular/core'
import { ReplaySubject } from 'rxjs'

/**
 * gets the productConfigurationId from the parent module implementing the checkout factory
 */
@Injectable()
export class ConfigurationIdResolver implements Resolve<number> {
    configurationId$ = new ReplaySubject<string>(1)

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): number {
        const configurationId =
            route.params.productConfigurationId ||
            route.data.productConfigurationId ||
            route.parent.data.productConfigurationId
        this.configurationId$.next(configurationId)
        return configurationId
    }
}
